import React, { useContext, useEffect, useState } from 'react'
import { FormGroup, Col, Label } from 'reactstrap'
import Resx from '@/components/Resx'
import { Validator } from '@/components/validation'
import { DropDownList } from '@/components/dropDownList'
import context from '@/context'
import { useLocalization } from '@/hooks/localization'
import { ValidationContext } from '@/components/validation/validationContext'

function CompanyReportInputs ({ value, onChange }) {
  const { localize } = useLocalization()
  const [company, setCompany] = useState(value.companyId)
  const [submission, setSubmission] = useState(value.reportGroupSubmissionId)
  const validationContext = useContext(ValidationContext)

  // Clear dependant fields
  useEffect(() => {
    validationContext.resetErrors(['makerUserId', 'bankId', 'reportGroupSubmissionId'])
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  function onCompanyChange ({ item }) {
    setCompany(item)
    setSubmission(null)
    onChange({ ...value,
      companyId: item ? item.id : null,
      institutionId: item ? item.institutionId : null,
      reportGroupSubmissionId: null
    })
  }

  function onSubmissionChange ({ item }) {
    setSubmission(item)
    onChange({ ...value, reportGroupSubmissionId: item ? item.id : null })
  }

  function setCompanyFilter (request) {
    if (!request.filter) {
      request.filter = { filters: [] }
    }
    request.filter.logic = 'and'
    request.filter.filters.push({ field: 'institutionId', operator: 'eq', value: company ? company.institutionId : 0 })

    return request
  }

  return (
    <FormGroup row>
      <Label sm='2' className='label'><Resx name='Tickets.SelectCompany' /></Label>
      <Col sm='4'>
        <Validator name='companyId' value={value.companyId} required>
          <DropDownList className='companySelector'
            dataSource={context.api.companyService.query}
            onChange={onCompanyChange} value={company} />
        </Validator>
      </Col>
      <Label sm='2' className='label'><Resx name='Tickets.ReportSubmissionGroup' /></Label>
      <Col sm='4'>
        <Validator name='reportGroupSubmissionId' value={value.reportGroupSubmissionId} required>
          <DropDownList className='reportSelector'
            key={company ? company.id : 0}
            disabled={!company}
            dataSource={request => context.api.reportSubmissionGroupService.getTableData(localize('Common.CBI'), false, setCompanyFilter(request))}
            onChange={onSubmissionChange} value={submission} />
        </Validator>
      </Col>
    </FormGroup>
  )
}

export {
  CompanyReportInputs
}



// WEBPACK FOOTER //
// ./src/dialogs/ticketTypes/companyReport.js